import React, { createContext, useReducer, useEffect } from 'react';
import { api } from 'api';

export const PaymentBehaviorContext = createContext();

export default function PaymentBehaviorProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    api.paymentBehavior.sharing().then(data => {
      if (!data.error) {
        dispatch({ type: 'UPDATE_COLLECTION', payload: data });
      }
    });
  }, []);

  return (
    <PaymentBehaviorContext.Provider value={state}>{children}</PaymentBehaviorContext.Provider>
  );
}

export const usePaymentBehavior = () => React.useContext(PaymentBehaviorContext);

function reducer(state, { type, payload }) {
  switch (type) {
    case 'UPDATE_COLLECTION':
      return {
        ...state,
        sharing: payload,
        status: 'loaded'
      };
    default:
      return state;
  }
}

const initialState = {
  status: 'loading',
  sharing: false
};
